import React from 'react';

import EditTemplate from '../../Components/Edit';
import Erros from './Erros';
import Form from './Form';
import validate from './Validation';

const Title = ({ record }) => (
  <span>Editar Colaborador: {record ? `"${record.nome}"` : ''}</span>
);

function transform({ nome, funcao_colaborador_id, ...data }) {
  return {
    nome,
    funcao_colaborador_id,
  };
}

const Edit = (props) => (
  <EditTemplate
    {...props}
    title={<Title />}
    validate={validate}
    onFailure={Erros}
    transform={transform}
    isBack
  >
    <Form />
  </EditTemplate>
);

export default Edit;
